var PresetEnum;
(function (PresetEnum) {
    PresetEnum["fast"] = "fast";
    PresetEnum["medium"] = "medium";
    PresetEnum["slow"] = "slow";
    PresetEnum["custom"] = "custom";
})(PresetEnum || (PresetEnum = {}));
export {};
//# sourceMappingURL=fusion-quote-receive-dto.js.map